/*
 * Copyright (c) 2023 Puratos. All rights reserved.
 */

import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hasRole, isLoggedIn, ROLES } from '../../../data/user.model';
import { fetchingSKUsAction, isLoadingById } from '../../../selectors/loader';
import { fetchProductSKUs } from '../../../actions/products';
import { getProductSKUs } from '../../../selectors/products';
import { ProductModal } from '../../molecules/product-modal/ProductModal';
import ModalProductRow from '../products/ModalProductRow';
import { ModalManager } from '../../components/ModalManager';
import * as $ from 'jquery';
import { GTMContextProvider } from '../../../analytics/ga4/utils/GTMContext';
import { addProductClickEvent } from '../../../utils/customEventHandler';
import {
    selectMyPuratosAccountEmail,
    selectUserId,
} from '../../../selectors/auth';
import { setProductCrossSell } from '../../../actions/analytics';
import { fetchBundles } from '../../../actions/my-puratos/promotions.action';
import { interactionCrossSellMapper } from '../../../analytics/ga4/utils/mapper';
import { getCurrencyCode } from '../../../selectors/cart';
import { googleEvents } from '../../../utils/googleEvents';
import { getLanguageIso } from '../../../selectors/generic';
import { GA4LoginType } from '../../../analytics/ga4/types/login';
import { GA4PageType } from '../../../analytics/ga4/types/page';
import { productEventParseSelect } from '../../../analytics/ga4/parsers/item';

export const ProductOrderingModalId = 'product-ordering';

export function ProductOrderingModal(props) {
    const loading = useSelector((state) =>
        isLoadingById(state, fetchingSKUsAction(props.payload.productId))
    );
    const skus = useSelector((state) =>
        getProductSKUs(state, props.payload.productId)
    );
    const userId = useSelector(selectUserId);
    const currency = useSelector(getCurrencyCode);
    const userEmail = useSelector(selectMyPuratosAccountEmail);
    const dispatch = useDispatch();

    useEffect(() => {
        if (hasRole(ROLES.valid)) {
            dispatch(fetchProductSKUs(props.payload.productId));
            dispatch(fetchBundles([props.payload.productId]));
        }
    }, [props.payload.productId]);

    useEffect(() => {
        const body = $('body');
        body.addClass('modal-open');
        return () => body.removeClass('modal-open');
    });

    const addEvent = (product) => {
        dispatch(
            setProductCrossSell({
                ...product,
                type: interactionCrossSellMapper(props.payload.type),
            })
        );
        addProductClickEvent(
            product,
            props.payload.type,
            true,
            userId,
            currency,
            1
        );
        googleEvents.selectItem({
            user_id: userId,
            page_language: getLanguageIso(),
            email_address: isLoggedIn() ? userEmail : '',
            login_status: userId ? GA4LoginType.LOGGED_IN : GA4LoginType.GUEST,
            website_section: GA4PageType.allProducts,
            items: productEventParseSelect(
                product,
                currency,
                props.payload.type
            ),
        });
    };

    return (
        <ProductModal skus={skus} loading={loading} title={'Select package'}>
            <GTMContextProvider type={props.payload.type}>
                {skus && (
                    <ModalProductRow
                        sku={skus}
                        addEvent={addEvent}
                        showBundles
                        hideCartAmountAlert={props.payload.hideCartAmountAlert}
                        productCategoryTag={props.payload.productCategoryTag}
                    />
                )}
            </GTMContextProvider>
        </ProductModal>
    );
}

ModalManager.modals[ProductOrderingModalId] = ProductOrderingModal;
